import Consts from 'Framework/Consts';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const MosaferatiHttpConfig = createAxiosHttpConfig({ baseURL: Consts.env.REACT_APP_MOSAFERATI_APP_BASE_URL });

export const MosaferatiHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: MosaferatiHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const MosaferatiHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: MosaferatiHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });

export default MosaferatiHttpConfig;
